module.exports = __webpack_public_path__ + "img/4_2.dcfb95b8.jpg";